var _module = require('./index');
var _ = require('lodash');

_module.directive('moneyNgModel', [
    '$log',
    '$filter',

    function moneyNgModel($log, $filter) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {},
            link: function moneyNgModelLink($scope, $elem, $attrs, ngModelCtrl) {
                ngModelCtrl.$formatters.push(filterNgModelFormatter);
                ngModelCtrl.$parsers.push(filterNgModelParser);

                // Listeners
                $elem.on('focus', function onChange(e) {
                    ngModelCtrl.$setViewValue(filterNgModelParser($elem.val()), 'focus');
                    ngModelCtrl.$render();
                });

                $elem.on('blur', function onChange(e) {
                    ngModelCtrl.$setViewValue(filterNgModelFormatter($elem.val()), 'blur');
                    ngModelCtrl.$render();
                });

                // Functions
                function filterNgModelFormatter(modelValue) {
                    if(!modelValue) return modelValue;

                    var value = parseFloat(String(modelValue || '').replace(/([^0-9\.])/gi, ''));
                    var maxDecimalPlaces = parseInt($attrs.moneyNgModel || 2);
                    var pow = Math.pow(10, maxDecimalPlaces);
                    value = String(Math.round(value * pow) / pow);

                    if(maxDecimalPlaces) {
                        if(!~value.indexOf('.')) {
                            value += '.';
                        }

                        var splitValue = value.split('.');
                        splitValue[1] = splitValue[1].padEnd(maxDecimalPlaces, '0');
                        value = splitValue.join('.');
                    }

                    return '$' + $filter('addCommasToNumber')(value);
                }

                function filterNgModelParser(viewValue) {
                    var value =  String(viewValue || '').replace(/([^0-9\.])/gi, '');

                    if(~value.indexOf('.')) {
                        value = value.substr(0, value.lastIndexOf('.') + 3);
                    }

                    return parseFloat(value) || undefined;
                }
            }
        };
    }
]);
